SP.lang.Class.define("SP.sitekit.form.field.File", {
	extend: "SP.sitekit.form.field.Field",

	init: function (el, options) {

		this._super.apply(this, arguments);

		var me = this;
		var button = this._el.querySelector("[data-sp-form-field-file-button]");
		button.addEventListener("click", function (e) {
			me._control.click();
			e.stopPropagation();
			e.preventDefault();
		});
		if (!this._control.hasAttribute("disabled")) {
			this._control.addEventListener("change", function () {
				var file = this.files.length >= 1 ? this.files[0] : null;
				var value = "";
				if (file !== null) {
					value = SP.lang.String.escapeHtml(file.name) + "; " + me.format(file.size) + " (" + SP.lang.String.escapeHtml(file.type) + ")";
				}
				me._el.querySelector("[data-sp-form-field-file-fileInfo]").innerHTML = value;
				// durch blur wird die Validierung getriggert.
				SP.dom.Event.triggerEvent(this, "blur");
			});
		}
	},

	format: function(size, decimals) {

		if (SP.isEmpty(size) || !SP.isNumber(size)) {
			return "";
		}
		if (arguments.length === 1) {
			decimals = 2;
		}

		var n = 0;
		var u = null;
		// kein ICE-Prefix daher kein vielfaches von 1024 sonder von 1000
		// Siehe https://de.wikipedia.org/wiki/Byte
		if (size < 1000) {
			n = size;
			u = "<abbr title=\"Byte\">B</abbr>";
		} else if (size < 1000000) {
			n = size / 1000;
			u = "<abbr title=\"Kilobyte\">kB</abbr>";
		} else if (size < 1000000000) {
			n = size / 1000000;
			u = "<abbr title=\"Megabyte\">MB</abbr>";
		} else if (size < 1000000000000) {
			n = size / 1000000000;
			u = "<abbr title=\"Gigabyte\">GB</abbr>";
		} else if (size < 1000000000000000 ) {
			n = size / 1000000000000;
			u = "<abbr title=\"Terrabyte\">TB</abbr>";
		} else if (size < 1000000000000000000 ) {
			n = size / 1000000000000000;
			u = "<abbr title=\"Petabyte\">PB</abbr>";
		} else if (size < 1000000000000000000000 ) {
			n = size / 1000000000000000000;
			u = "<abbr title=\"Exabyte\">EB</abbr>";
		} else {
			n = size / 1000000000000000000000;
			u = "<abbr title=\"Zettabyte\">ZB</abbr>";
		}

		return n.toLocaleString(
				undefined, // use a string like 'en-US' to override browser locale
				{ minimumFractionDigits: decimals, maximumFractionDigits: decimals }
		) + " " + u;
	}

});
